import React from "react";
import styled from "styled-components";
import {RedactCommentary} from "../../../redact/RedactCommentary";
import {logAction} from "../../../../logging/logEvent";
import {ExpandableText} from "../../../elements/ExpandableText";

const Container = styled.div`
    flex-grow: 1;
    width: 100px;
    flex-shrink: 0;
`;

export const CommentaryHeader = () => {
    return <Container className="t-commentary-header">Commentary</Container>;
};

export const CommentaryCell = ({activity: {action, commentary}, idea: {ideaId}}) => {
    const onSeeMore = (seeMore) => {
        logAction({
            type: seeMore ? "IDEA_HISTORY_COMMENTARY_SEE_MORE" : "IDEA_HISTORY_COMMENTARY_SEE_LESS",
            action,
            ideaId
        })
    };

    return (
        <Container>
            <RedactCommentary>
                <ExpandableText text={commentary}
                                onClick={onSeeMore}
                                limit="500"
                                fontSize="14px"
                                className="t-commentary"/>
            </RedactCommentary>
        </Container>
    );

};
